import { Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';
import { Subject } from 'rxjs';
import { FuseMediaWatcherService } from '../../../@fuse/services/media-watcher';

@Injectable()
export class CustomPaginatorIntl implements MatPaginatorIntl {
    changes = new Subject<void>();
    isMobile = signal<boolean>(false);

    firstPageLabel = this.translocoService.translate(`mat-paginator-intl.first-page`);
    itemsPerPageLabel = this.translocoService.translate(`mat-paginator-intl.items-per-page`);
    lastPageLabel = this.translocoService.translate(`mat-paginator-intl.last-page`);
    nextPageLabel = this.translocoService.translate(`mat-paginator-intl.next-page`);
    previousPageLabel = this.translocoService.translate(`mat-paginator-intl.prev-page`);

    // You can set labels to an arbitrary string too, or dynamically compute
    // it through other third-party internationalization libraries.

    constructor(
        private translocoService: TranslocoService,
        private fuseMediaWatcherService: FuseMediaWatcherService
    ) {
        this.fuseMediaWatcherService.onMediaChange$.pipe(takeUntilDestroyed()).subscribe(({ matchingAliases }) => {
            this.isMobile.set(!matchingAliases.includes('md'));
        });
    }

    getRangeLabel(page: number, pageSize: number, length: number): string {
        const totalPages = length === 0 ? 1 : Math.ceil(length / pageSize);
        return this.translocoService.translate(
            this.isMobile() ? `mat-paginator-intl.range-mobile` : `mat-paginator-intl.range`,
            {
                currentPage: page + 1,
                totalPages: totalPages,
                totalItems: length,
            }
        );
    }
}
